// extracted by mini-css-extract-plugin
export default {"wrapper":"UM-z","firstToReview":"VM-z","productCards":"WM-z","productCard":"XM-z","stars":"YM-z","hidden":"ZM-z"};